import { Injectable } from '@angular/core';
import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';
import {
  contractingAuthorityInitialState,
  ContractingAuthorityStateProps,
  contractingAuthorityStateStore,
} from './contracting-authority-state.store';

@Injectable({
  providedIn: 'root',
})
export class ContractingAuthorityRepository extends BaseStoreRepository<ContractingAuthorityStateProps> {
  constructor() {
    super(contractingAuthorityStateStore.pipe(select(state => state)), contractingAuthorityStateStore, contractingAuthorityInitialState);
  }
}
